module.exports = __webpack_public_path__ + "img/Gallery_2_37.ecd7a652.jpeg";